export default __webpack_public_path__ + "static/media/ethereumLogo.a1b9f99b.png";